var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.creatorRequestDispute.settled)?_c('div',{staticClass:"text-success"},[_c('font-awesome-icon',{staticClass:"text-success",attrs:{"icon":"fa-light fa-check-circle"}}),_vm._v(" Settled ")],1):_c('div',{staticClass:"text-warning"},[_c('font-awesome-icon',{attrs:{"icon":"fa-duotone fa-triangle-exclamation"}}),_vm._v(" Unsettled ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }